import { useEffect } from 'react';
import { connectFixStream } from './api';
import { clientSim } from './sim/clientSim';
import { useStore } from './store';
import { MapView } from './components/MapView';
import { BurgerMenu } from './components/BurgerMenu';
import { MapStyleButton } from './components/MapStyleButton';
import { LocateButton } from './components/LocateButton';
import { EditorBar } from './components/EditorBar';
import { StatusBar } from './components/StatusBar';
import { FieldPanel } from './components/FieldPanel';
import { CoursePanel } from './components/CoursePanel';
import { DrivingHud } from './components/DrivingHud';

export default function App() {
  const phase = useStore((s) => s.phase);
  const bootDone = useStore((s) => s.bootDone);

  // Boot: fetch config + (cloud) Keycloak login redirect. Auth is handled before bootDone flips.
  useEffect(() => {
    void useStore.getState().bootstrap();
  }, []);

  // Open the live fix stream once booted (and authenticated, in cloud mode). While the browser test
  // sim is active it is the sole fix source — ignore WS fixes so the two don't interleave into one
  // trail (connection status still tracks the real socket).
  useEffect(() => {
    if (!bootDone) return;
    return connectFixStream(
      (fix) => {
        if (!clientSim.active) useStore.getState().setFix(fix);
      },
      (up) => useStore.getState().setConnected(up),
    );
  }, [bootDone]);

  if (!bootDone) return <div className="h-dvh w-dvw bg-field-night" />;

  return (
    <div className="relative h-dvh w-dvw overflow-hidden bg-field-night text-white">
      <MapView />
      <StatusBar />
      <MapStyleButton />
      <LocateButton />
      <BurgerMenu />
      <EditorBar />
      {(phase === 'idle' || phase === 'field') && <FieldPanel />}
      {phase === 'course' && <CoursePanel />}
      {(phase === 'driving' || phase === 'paused') && <DrivingHud />}
    </div>
  );
}
